// extracted by mini-css-extract-plugin
export default {"formRadios":"modelo_formRadios__YWwi1","modeloLista":"modelo_modeloLista__dgSTU"};